import { CIcon } from '~/icons/types'

export const ciRealEstate: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm18 5.047 2 1.5 1 .7v-2.7a1.075 1.075 0 0 0-1-1h-2a1.077 1.077 0 0 0-1 .8l.6.4.4.3Zm4.8 15.203H21v-7.8H3v7.8H1.2a.713.713 0 0 0-.7.8.773.773 0 0 0 .7.8h21.6a.807.807 0 0 0 0-1.6Zm-12.3 0H6v-5.5a1.075 1.075 0 0 1 1-1h2.5a1.076 1.076 0 0 1 1 1v5.5Zm7.5-2.8a.987.987 0 0 1-.9 1h-2.7a.986.986 0 0 1-.9-1v-2.6a.987.987 0 0 1 .9-1h2.7a.987.987 0 0 1 .9 1v2.6ZM2 11.548h20a1.2 1.2 0 0 0 1-.7 1.127 1.127 0 0 0-.3-1.1l-1.7-1.2-4-3-4.4-3.2a1.42 1.42 0 0 0-.6-.2c-.213.021-.418.09-.6.2l-10 7.4a.947.947 0 0 0-.3 1.1.96.96 0 0 0 .9.7Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'real-estate',
  type: 'solid'
}
